import { createComponent } from '@helpers/admin';
import { YayCustomerReviewsSectionComponent } from '@template/blocks/CustomerReviewsSection/component';

export const Reviews = createComponent({
  label: 'Reviews',
  component: YayCustomerReviewsSectionComponent,
  fields: {
    headline: {
      label: 'Headline',
      type: 'textarea',
    },
    cta: {
      label: 'CTA',
      type: 'object',
      objectFields: {
        text: {
          label: 'Text',
          type: 'textarea',
        },
        href: {
          label: 'Href',
          type: 'textarea',
        },
      },
    },
    reviewType: {
      label: 'Review Type',
      type: 'select',
      options: [
        {
          label: 'Custom',
          value: 'custom',
        },
        {
          label: 'TrustPilot',
          value: 'trustpilot',
        },
        {
          label: 'None',
          value: 'none',
        },
      ],
      default: 'custom',
    },
    extended: {
      label: 'Extended',
      type: 'boolean',
    },
    internal: {
      label: 'Show Header',
      type: 'boolean',
      default: true,
    },
    showFooter: {
      label: 'Show Footer',
      type: 'boolean',
      default: true,
    },
  },
});
